module.exports = __webpack_public_path__ + "img/ie.e620d9fa.svg";